import * as React from "react";

import { Card, ICardProps } from "@blueprintjs/core";
import styled from "~/styled";

const CardWrapper = styled(Card)`
  @media (max-width: 320px) {
    padding: 10px;
  }
`;

export class StyledCard extends React.Component<ICardProps> {
  public render() {
    return <CardWrapper {...this.props}>{this.props.children}</CardWrapper>;
  }
}



// WEBPACK FOOTER //
// ./src/layouts/StyledCard.tsx